// Side-effect import: registers the hub's tracing extension methods. v6's
// @sentry/nextjs did this internally, v7 only does it inside Sentry.init() -
// and init is skipped when APP_ENV is "local" and never runs under Jest, so
// without this startTransaction returns undefined and every call site throws.
import "@sentry/tracing";
import { getCurrentHub, startTransaction } from "@sentry/nextjs";
import { TransactionContext } from "@sentry/types";

export enum SpanStatus {
  Ok = "ok",
  UnknownError = "unknown_error",
}

export const SentryHelpers = {
  startTransaction: (context: TransactionContext) => {
    const transaction = startTransaction(context);
    getCurrentHub().configureScope((scope) => scope.setSpan(transaction));

    return transaction;
  },
};
